module.exports = __webpack_public_path__ + "assets/img/staff.bbe6c7b8.svg";